import type { RouteCandidate } from "./settings-types";
export const confidenceLabel = {
    HIGH: "Yüksek güven",
    MEDIUM: "Orta güven",
    LOW: "Düşük güven",
} as const;
export function evidenceNote(candidate: RouteCandidate, productCode: string, days: number) {
    return `${productCode} reçete malzemelerinin son ${days} günlük Mikro transfer geçmişi: ${candidate.mainWarehouse.code}→${candidate.handoffWarehouse.code} ${candidate.mainToHandoffMovementCount} hareket, ${candidate.handoffWarehouse.code}→${candidate.stagingWarehouse.code} ${candidate.handoffToStagingMovementCount} hareket. ${confidenceLabel[candidate.confidence]}; sistem yöneticisi tarafından doğrulandı.`;
}
